<template>
  <el-card class="card-main">
    <el-radio-group v-model="activeName" @change="changeComponentName" class="radioGroup">
      <el-radio-button label="0">工人考勤</el-radio-button>
      <el-radio-button label="1">班组考勤</el-radio-button>
      <el-radio-button label="2">加班记录</el-radio-button>
    </el-radio-group>
    <div class="main">
      <component :is="componentName"></component>
    </div>
  </el-card>
</template>

<script>
import WorkerList from './WorkerList.vue'
import TeamsList from './TeamsList.vue'
import ExtraworkList from './ExtraworkList.vue'
// @KeepAlive
export default {
  name: 'laborManageAttendance',
  components: {
    WorkerList, TeamsList, ExtraworkList
  },
  data () {
    return {
      activeName: '0',
      componentName: 'WorkerList'
    }
  },
  methods: {
    changeComponentName (val) {
      if (val === '0') {
        this.componentName = 'WorkerList'
      } else if (val === '1') {
        this.componentName = 'TeamsList'
      } else {
        this.componentName = 'ExtraworkList'
      }
    }

  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 0;
}

.radioGroup {
  margin: 0 0 20px;
}
</style>
